var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "资金流水详情",
        visible: _vm.visible,
        footer: null,
        width: "800px",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-descriptions",
        { attrs: { column: 2, bordered: "" } },
        [
          _c("a-descriptions-item", { attrs: { label: "流水ID" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.id) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "条数" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.serialNumber) + " "),
          ]),
          _c(
            "a-descriptions-item",
            { attrs: { label: "变更类型" } },
            [
              _c(
                "a-tag",
                {
                  attrs: {
                    color: _vm.getChangeTypeColor(_vm.detailData.changeType),
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.getChangeTypeText(_vm.detailData.changeType)) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("a-descriptions-item", { attrs: { label: "变更金额" } }, [
            _c(
              "span",
              {
                class: [
                  "amount-text",
                  _vm.detailData.changeAmount > 0
                    ? "amount-positive"
                    : "amount-negative",
                ],
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formatChangeAmount(_vm.detailData.changeAmount)
                    ) +
                    " "
                ),
              ]
            ),
          ]),
          _c("a-descriptions-item", { attrs: { label: "手续费" } }, [
            _c("span", { staticClass: "fee-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.fee))),
            ]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "变更前余额" } }, [
            _c("span", { staticClass: "balance-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.balanceBefore))),
            ]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "变更后余额" } }, [
            _c("span", { staticClass: "balance-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.balanceAfter))),
            ]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "币种" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.currency || "INR") + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "订单ID", span: 2 } }, [
            _c(
              "div",
              { staticClass: "order-info" },
              [
                _c("span", [_vm._v(_vm._s(_vm.detailData.orderNo))]),
                _c("CopyButton", { attrs: { text: _vm.detailData.orderNo } }),
              ],
              1
            ),
          ]),
          _c(
            "a-descriptions-item",
            { attrs: { label: "商户订单ID", span: 2 } },
            [
              _c(
                "div",
                { staticClass: "order-info" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.detailData.mchOrderNo))]),
                  _c("CopyButton", {
                    attrs: { text: _vm.detailData.mchOrderNo },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("a-descriptions-item", { attrs: { label: "订单时间", span: 2 } }, [
            _vm._v(" " + _vm._s(_vm.detailData.orderTime) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "创建时间", span: 2 } }, [
            _vm._v(" " + _vm._s(_vm.detailData.createdAt) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "更新时间", span: 2 } }, [
            _vm._v(" " + _vm._s(_vm.detailData.updatedAt) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "备注信息", span: 2 } }, [
            _c("div", { staticClass: "remark-content" }, [
              _vm._v(" " + _vm._s(_vm.detailData.remark || "--") + " "),
            ]),
          ]),
        ],
        1
      ),
      _c("a-divider", [_vm._v("扩展信息")]),
      _vm.detailData.extendInfo &&
      Object.keys(_vm.detailData.extendInfo).length > 0
        ? _c(
            "div",
            [
              _c(
                "a-descriptions",
                { attrs: { column: 1, bordered: "" } },
                _vm._l(_vm.detailData.extendInfo, function (value, key) {
                  return _c(
                    "a-descriptions-item",
                    { key: key, attrs: { label: key } },
                    [
                      _c("pre", { staticClass: "json-content" }, [
                        _vm._v(_vm._s(_vm.formatJsonValue(value))),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "no-extend-info" },
            [_c("a-empty", { attrs: { description: "暂无扩展信息" } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }